import { render, staticRenderFns } from "./PublicFormItem.vue?vue&type=template&id=33593f7e&scoped=true&"
import script from "./PublicFormItem.vue?vue&type=script&lang=ts&"
export * from "./PublicFormItem.vue?vue&type=script&lang=ts&"
import style0 from "./PublicFormItem.vue?vue&type=style&index=0&id=33593f7e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33593f7e",
  null
  
)

export default component.exports